// extracted by mini-css-extract-plugin
export default {"bg":"home_bg__cH76a","heroimg":"home_heroimg__wo0Il"};